import { twMerge } from 'tailwind-merge';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export const AuthLayout: React.FC<Props> = ({ children, className }) => {
  return (
    <div className={twMerge('relative h-screen w-screen', className)}>
      <div className="absolute inset-0 -z-10 overflow-hidden bg-black/40 backdrop-blur" />
      <div className="absolute inset-0 -z-10 overflow-hidden bg-signin bg-cover bg-top opacity-25" />
      <div className="absolute inset-0 -z-10 overflow-hidden backdrop-blur-sm" />
      <div className="flex min-h-full w-full flex-col overflow-y-auto rounded-none bg-white px-6 py-12 sm:absolute sm:left-[50%] sm:top-[50%] sm:max-h-[calc(100vh-40px)] sm:min-h-0 sm:w-[400px] sm:translate-x-[-50%] sm:translate-y-[-50%] sm:rounded-2xl sm:rounded-tl-none sm:p-10 sm:shadow-lg">
        {children}
      </div>
    </div>
  );
};
